// assets/cart-gclid.js
(function () {
  var params = new URLSearchParams(window.location.search);
  var ids = { gclid: 'gclid', gbraid: 'gbraid', wbraid: 'wbraid' };
  var found = {};

  Object.keys(ids).forEach(function (key) {
    var val = params.get(key);
    if (val) {
      found[key] = val;
      localStorage.setItem(key, val);
      localStorage.setItem(key + '_ts', Date.now());
    }
  });

  // Optional: expire stored click ids after N days (Google's own
  // attribution windows are usually 30-90 days depending on network)
  var maxAgeMs = 30 * 24 * 60 * 60 * 1000;
  Object.keys(ids).forEach(function (key) {
    var ts = localStorage.getItem(key + '_ts');
    if (ts && Date.now() - Number(ts) > maxAgeMs) {
      localStorage.removeItem(key);
      localStorage.removeItem(key + '_ts');
    }
  });

  var stored = {};
  Object.keys(ids).forEach(function (key) {
    var v = localStorage.getItem(key);
    if (v) stored[key] = v;
  });

  if (Object.keys(stored).length === 0) return;

  // Merge into existing cart attributes rather than clobbering them —
  // fetch current cart first
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var merged = Object.assign({}, cart.attributes, stored);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: merged })
      });
    })
    .catch(function (err) {
      console.error('cart-gclid attribute update failed', err);
    });
})();